/** Named navigation stack with an ordered path history (Capacitor shell). */
export interface NavigationStackEntry {
    paths: string[]
    name: string
}

/**
 * Most recently used prior stack: `stacks[length - 2]`, or null when fewer than two exist.
 * Matches `useNavigationStackStore` `previousStack` (MRU ordering).
 */
export function getPreviousStackEntry<T extends NavigationStackEntry>(stacks: T[]): T | null {
    return stacks.length >= 2 ? stacks[stacks.length - 2]! : null
}
